import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5 py-4" }
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-4" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "mt-1 text-sm text-gray-700" }
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-amber-700"
}
const _hoisted_8 = {
  key: 1,
  class: "mt-1 text-xs text-gray-500"
}
const _hoisted_9 = {
  key: 0,
  class: "flex shrink-0 gap-2"
}
const _hoisted_10 = {
  key: 1,
  class: "flex shrink-0 flex-wrap gap-2"
}
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-gray-500"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_13 = { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }
const _hoisted_14 = {
  key: 0,
  class: "mt-1 divide-y divide-gray-100"
}
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = { class: "truncate text-sm text-gray-900" }
const _hoisted_17 = { class: "text-xs text-gray-500" }
const _hoisted_18 = {
  "data-test": "identity",
  class: "text-xs text-gray-500"
}
const _hoisted_19 = {
  key: 3,
  class: "mt-2 text-sm text-red-600",
  role: "alert"
}

import { computed, ref, watch } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import ParsleyItemPicker from '@/components/parsley/ParsleyItemPicker.vue'
import { formatDateTime, itemDescription, itemIdentity, linkNeedsAttention, linkStatusLabel } from '@/helpers/parsley'
import { errorMessage, parsleyApi } from '@/services/parsleyApi'

const LINK_ERROR = "Couldn't link this product. Please try again."
const UNLINK_ERROR = "Couldn't unlink this product. Please try again."
const UNLINK_NOTE = 'The product keeps the data it last received and becomes editable again.'


export default {
  __name: 'ParsleyProductRow',
  props: {
  match: { type: Object, required: true }
},
  emits: ['changed'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const picking = ref(false)
const busy = ref(false)
const error = ref('')
// Unlinking removes the source of the nutrition customers see, so it takes a
// second click, as Disconnect does on the connection card.
const confirmingUnlink = ref(false)

const link = computed(() => props.match.attributes.link)
// A confirmed link is never second-guessed, so a linked product shows none.
const suggestions = computed(() => (link.value ? [] : props.match.attributes.suggestions ?? []))
const linkedItem = computed(() => ({
  item_type: link.value.parsley_item_type,
  serving_basis_label: link.value.serving_basis_label
}))
// A refused request's message belongs to the row as it was, not as reloaded.
watch(
  () => props.match,
  () => {
    error.value = ''
  }
)

const attention = computed(() => linkNeedsAttention(link.value.status))
const statusText = computed(() => {
  const label = linkStatusLabel(link.value.status)
  return link.value.synced_at ? `${label}. Last synced ${formatDateTime(link.value.synced_at)}` : label
})

const change = async (request, fallback) => {
  if (busy.value) return
  busy.value = true
  error.value = ''
  try {
    await request()
    picking.value = false
    confirmingUnlink.value = false
    emit('changed')
  } catch (failure) {
    error.value = errorMessage(failure, fallback)
  } finally {
    busy.value = false
  }
}

const choose = menuItemId =>
  change(
    () => (link.value ? parsleyApi.relink(link.value.id, menuItemId) : parsleyApi.link(props.match.id, menuItemId)),
    LINK_ERROR
  )

const unlink = () => change(() => parsleyApi.unlink(link.value.id), UNLINK_ERROR)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: `/store/products/${__props.match.id}`,
          class: "text-sm font-semibold text-gray-900 hover:underline"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.match.attributes.product_name), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        (link.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", _hoisted_4, [
                _cache[5] || (_cache[5] = _createTextVNode(" Linked to ", -1)),
                _createElementVNode("span", _hoisted_5, _toDisplayString(link.value.parsley_name), 1)
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(itemDescription)(linkedItem.value)), 1),
              _createElementVNode("p", {
                "data-test": "status",
                class: _normalizeClass(["mt-1 text-xs", attention.value ? 'text-amber-700' : 'text-gray-500'])
              }, _toDisplayString(statusText.value), 3),
              (link.value.last_error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(link.value.last_error), 1))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("p", _hoisted_8, "Not linked"))
      ]),
      (link.value && !confirmingUnlink.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(NeueButton, {
              type: "secondary",
              disabled: busy.value,
              onClick: _cache[0] || (_cache[0] = $event => (picking.value = !picking.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(picking.value ? 'Cancel' : 'Change'), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(NeueButton, {
              type: "secondary",
              disabled: busy.value,
              onClick: _cache[1] || (_cache[1] = $event => (confirmingUnlink.value = true))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Unlink", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : (link.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(NeueButton, {
                type: "secondary",
                onClick: _cache[2] || (_cache[2] = $event => (confirmingUnlink.value = false))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Keep link", -1)
                ]))]),
                _: 1
              }),
              _createVNode(NeueButton, {
                type: "red",
                loading: busy.value,
                onClick: unlink
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("Unlink from Parsley", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]))
          : _createCommentVNode("", true)
    ]),
    (link.value && confirmingUnlink.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(UNLINK_NOTE)))
      : _createCommentVNode("", true),
    (!link.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(suggestions.value.length ? 'Suggestions' : 'No suggestions'), 1),
          (suggestions.value.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (suggestion) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: suggestion.id,
                    "data-test": "suggestion",
                    class: "flex items-center justify-between gap-4 py-2"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(suggestion.name), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(itemDescription)(suggestion)), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(itemIdentity)(suggestion)), 1)
                    ]),
                    _createVNode(NeueButton, {
                      type: "secondary",
                      disabled: busy.value,
                      onClick: $event => (choose(suggestion.id))
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("Link", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(NeueButton, {
            type: "secondary",
            class: "mt-2",
            disabled: busy.value,
            onClick: _cache[3] || (_cache[3] = $event => (picking.value = !picking.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(picking.value ? 'Hide search' : 'Search Parsley'), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    (picking.value)
      ? (_openBlock(), _createBlock(ParsleyItemPicker, {
          key: 2,
          class: "mt-3",
          onSelect: _cache[4] || (_cache[4] = item => choose(item.id))
        }))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}